import { EntityClaim } from "../../entity/EntityClaim";

export class DtoClaimsDeleteRes extends EntityClaim {
  public message: string | null = null;
}
